export const rightSideNavList = [
  {
    text: 'General information',
    link: '?name=generalInformation',
    query: { type: 'name', value: 'generalInformation' },
  },
  {
    text: 'Connections',
    link: '?name=connections',
    query: { type: 'name', value: 'connections' },
  },
  {
    text: 'Appointments',
    link: '?name=appointments-current',
    children: [
      {
        text: 'Current',
        query: { type: 'name', value: 'appointments-current' },
      },
      {
        text: 'Past',
        query: { type: 'name', value: 'appointments-past' },
      },
      {
        text: 'Pending',
        query: { type: 'name', value: 'appointments-pending' },
      },
    ],
  },
  {
    text: 'Groups',
    link: '?name=groups',
    query: { type: 'name', value: 'groups' },
  },
  {
    text: 'Availability',
    link: '?name=availability',
    query: { type: 'name', value: 'availability' },
  },
  {
    text: 'Services',
    link: '?name=services',
    query: { type: 'name', value: 'services' },
  },
  {
    text: 'ePrescribe Access',
    link: '?name=MDToolboxAccess',
    query: { type: 'name', value: 'MDToolboxAccess' },
  },
  {
    text: 'CAQH Access',
    link: '?name=CAQHAccess',
    query: { type: 'name', value: 'CAQHAccess' },
  },
  {
    text: 'CAQH Information',
    link: '?name=CAQHInformation',
    query: { type: 'name', value: 'CAQHInformation' },
  },
  {
    text: 'Board certifications',
    link: '?name=boardCertifications',
    query: { type: 'name', value: 'boardCertifications' },
  },
  {
    text: 'Licenses',
    link: '?name=licenses',
    query: { type: 'name', value: 'licenses' },
  },
  {
    text: 'DEA / CDS Numbers',
    link: '?name=DEACDSNumbers',
    query: { type: 'name', value: 'DEACDSNumbers' },
  },
  {
    text: 'Degrees',
    link: '?name=degrees',
    query: { type: 'name', value: 'degrees' },
  },
  {
    text: 'Malpractice coverage',
    link: '?name=malpracticeCoverage',
    query: { type: 'name', value: 'malpracticeCoverage' },
  },
];

export const headings = {
  generalInformation: 'General information',
  connections: '',
  'appointments-current': '',
  'appointments-past': '',
  'appointments-pending': '',
  groups: 'Groups',
  availability: 'Availability',
  services: 'Services',
};
